import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";

import Header from "./sigma/Header";
import Footer from "./sigma/Footer";
import Home from "./sigma/views/Home";
import Catalogue from "./sigma/views/Catalogue";
import CategoryPage from "./sigma/views/CategoryPage";
import ProductPage from "./sigma/views/ProductPage";
import About from "./sigma/views/About";
import Faq from "./sigma/views/Faq";
import Brands from "./sigma/views/Brands";
import Contact from "./sigma/views/Contact";
import NotFound from "./sigma/views/NotFound";
import { colors } from "./sigma/theme";

// Scroll to top on every route change — unless the URL carries a hash, in
// which case scroll to that element instead. The logo strip links into
// /brands#<brand>, and without this the scroll-to-top would fire immediately
// after and land the reader back at the masthead every time.
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        {/* --app-min-h is 100dvh where supported, 100vh elsewhere (see
            index.css). On iOS Safari 100vh is the *large* viewport — the one
            with the URL bar retracted — so a short page such as /404 or the
            submitted contact form ended up ~90px taller than the screen and
            scrolled for no reason. The flex column lets the footer take
            `margin-top: auto` and sit at the bottom instead of floating
            mid-screen with cream below it. */}
        <div style={{ minHeight: "var(--app-min-h, 100vh)", background: colors.bg, display: "flex", flexDirection: "column" }}>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalogue" element={<Catalogue />} />
            <Route path="/catalogue/:slug" element={<CategoryPage />} />
            <Route
              path="/catalogue/:slug/:productSlug"
              element={<ProductPage />}
            />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/contact" element={<Contact />} />
            {/* Unknown paths render a real 404 page rather than silently
                redirecting home — a redirect turns every dead link into a soft
                404, which wastes crawl budget and hides broken inbound links. */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
